import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class OauthService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) { }

  startOAuth(context: any): void {

    this.loadingSubject.next(true); // show spinner

    const journalCode: String = context.journalCode;
    const state = btoa(JSON.stringify(context));

    const params = new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: environment.client_id,
      scope: 'diversity-reporting',
      response_type: 'code',
      redirect_uri: environment.redirectURL,
      state: state
    });


    window.location.href =
      `${environment.oauthUrl}/${journalCode}/oauth2/authorize?${params.toString()}`;
  }

  // Send code to Lambda
  handleOAuthCallback(code: string, context: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/oauth/exchange`,
      { code, ...context }
    );
  }

  finishOAuth(): void {
    this.loadingSubject.next(false); // hide spinner
  }


}
